import { render, staticRenderFns } from "./submitReport.vue?vue&type=template&id=473998fc&scoped=true&"
import script from "./submitReport.vue?vue&type=script&lang=js&"
export * from "./submitReport.vue?vue&type=script&lang=js&"
import style0 from "./submitReport.vue?vue&type=style&index=0&id=473998fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473998fc",
  null
  
)

export default component.exports